import { Port } from './port';

export interface PortsStoreState {
  readonly ports: Port[];
  readonly isFetchingPorts: boolean;
  readonly fetchError: string | undefined;
}

export const INITIAL_PORT_STORE_STATE: PortsStoreState = {
  ports: [] as Port[],
  isFetchingPorts: false,
  fetchError: undefined,
};
